import React from "react";
import { Outlet } from "react-router-dom";
const BlogRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default BlogRoot;
